import React from 'react'

function BottomBar() {
  return (
    <>
    <div className='' style={{bottom:'0px', position:'absolute'}}>
    <div class="row clearfix start-50 translate-middle-x" style={{paddingLeft: 260, width: '1920px'}}>
            <div class="col-lg-12">
                <div class="card">
                    <div class="body">
                        <p class="m-b-0">Copyright © 2023 Ballina's </p>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </>
  )
}

export default BottomBar
